// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__12c0T","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3AEgi"};